module.exports = __webpack_public_path__ + "img/__icon_IZOTERMA.5fc18379.svg";